import React from "react";
import { Breadcrumb } from "../../../components/Breadcrumb";

export const Documents = () => {
    document.title = "Sənədlər";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Göstəricilər", value: "/dashboard" },
        { name: "Sənədlər", value: "/dashboard/main", current: true },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <article>
                    <h2 className="my-4">Sənədlər</h2>
                    <p>
                        Sistem daxilində yaradılan bütün sənədlərin əks olunduğu səhifədir. <button className="new-button">Filter</button> seçimi ilə eyni anda
                        müxtəlif parametrlərə görə axtarış edib sənədlər ilə tanış olmaq olar
                    </p>
                    <img src="/images/dashboard/documents.gif" alt="documents" />
                </article>
            </div>
        </div>
    );
};
